"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobGroup = void 0;
var job_1 = require("./job");
// TODO: convert Job<any>[] to a more typed solution
// For this will need to move specifications to discriminated unions
var JobGroup = /** @class */ (function () {
    function JobGroup(data) {
        this.jobs = [];
        this.groupId = data.groupId;
        this.jobs = data.jobs.map(function (jobData) { return new job_1.Job(jobData); });
    }
    JobGroup.prototype.isWaiting = function () {
        return this.jobs.some(function (job) { return job.isWaiting(); });
    };
    JobGroup.prototype.isError = function () {
        return this.jobs.some(function (job) { return job.isError(); });
    };
    JobGroup.prototype.isSuccess = function () {
        return this.jobs.every(function (job) { return job.isSuccess(); });
    };
    return JobGroup;
}());
exports.JobGroup = JobGroup;
//# sourceMappingURL=job-group.js.map